getChildMergeTree